import React, { Component } from 'react';
import ConversationListItem from './conversationListItem';

export default class ChatList extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     conversations: []
  //   };
  // }

  // // componentDidMount() {
  // //   this.setConversations();
  // // }

  // // componentDidUpdate(prevProps) {
  // //   if (prevProps.chatList !== this.props.chatList) {
  // //     this.setConversations();
  // //   }
  // // }

  // // setConversations = () => {
  // //   const { chatList } = this.props;
  // //   if (chatList.length > 0 ) {
  // //     axios.get(`https://randomuser.me/api/?results=${chatList.length}`).then(response => {
  // //       this.setState(prevState => {
  // //         let conversations = response.data.results.map((result, i) => {
  // //           let lastText = "";
  // //           if (chatList[i].history.length > 0) {
  // //             lastText = chatList[i].history[chatList[i].history.length - 1].text;
  // //           }
  // //           return {
  // //             photo: result.picture.large,
  // //             name: `${chatList[i].otherUserName} ${chatList[i].otherUserLastName}`,
  // //             lastText,
  // //             channel: chatList[i].channel,
  // //             conversation: chatList[i]
  // //           };
  // //         });
          
  // //         return { ...prevState, conversations };
  // //       });
  // //     });
  // //   }
  // // }

  render() {
    return (
      <div className="conversation-list">
        {
          this.props.chatList.map(conversation =>
            <ConversationListItem
              key={conversation.name}
              data={conversation}
              changeConversation={this.props.changeConversation}
              selected={this.props.selected}
            />
          )
        }
      </div>
    );
  }
}